/**
 * Created by Bart Decorte
 * Date: 2019-07-17
 * Time: 10:56
 */
import Column from "./Column";

class UrlColumn extends Column {

  constructor(params) {
    super(params);
    this.init();
  }

}

export default UrlColumn;


// WEBPACK FOOTER //
// ./resources/assets/js/columns/UrlColumn.js